'use es6';

import { SET_SETTING_OPTIMIZATION_TYPE, SET_XRAY_PAGE_TITLE, SET_XRAY_META_DESC, SET_XRAY_READABILITY, CLEAR_XRAY_READABILITY, SET_XRAY_INPAGE_GATHERER_ARTIFACTS, SET_XRAY_INPAGE_GATHERER_KEYS } from 'ContentEditorUI/redux/actions/actionTypes';
import { updateSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { setScrollTo } from 'ContentEditorUI/redux/actions/baseSettingsActions';
import { toCamelCase } from 'ContentEditorUI/utils/helpers';
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { SETTING_REC_TYPE_TO_FIELD_MAP } from 'ContentEditorUI/lib/xray/constants';
import { getGathererKeys, getSettingsFieldForContentType } from 'ContentEditorUI/utils/xrayUtils';
import { getIsBlogPost } from '../selectors/contentReadOnlyDataSelectors';
import { GathererConfig, GathererExecutionLocations } from 'xray-recommendation-lib/gatherers/allGatherers';
export const selectModuleForXray = moduleId => {
  return dispatch => {
    dispatch(updateSelectedItem(moduleId));
  };
};
export const setSettingOptimizationType = optimizationType => {
  return {
    type: SET_SETTING_OPTIMIZATION_TYPE,
    payload: {
      optimizationType
    }
  };
};
export const openSettingsForXRay = optimizationType => {
  const field = SETTING_REC_TYPE_TO_FIELD_MAP[optimizationType];
  const camelCaseField = toCamelCase(field);
  return (dispatch, getState) => {
    const state = getState();
    const isBlogPost = getIsBlogPost(state);
    const patagoniaScrollToField = getSettingsFieldForContentType(camelCaseField, isBlogPost);
    dispatch(setSettingOptimizationType(optimizationType));
    dispatch(openModal(MODAL_TYPES.SETTINGS_MODAL));
    dispatch(setScrollTo(patagoniaScrollToField));
  };
};
export const setXrayPageTitle = pageTitle => {
  return {
    type: SET_XRAY_PAGE_TITLE,
    payload: {
      pageTitle
    }
  };
};
export const setXrayMetaDesc = metaDesc => {
  return {
    type: SET_XRAY_META_DESC,
    payload: {
      metaDesc
    }
  };
};
export const setXrayInpageGathererKeys = config => {
  const gathererKeys = getGathererKeys(config);
  const inpageGathererKeys = gathererKeys.filter(key => {
    const gatherer = GathererConfig[key];
    return gatherer.location === GathererExecutionLocations.INPAGE_EDITOR;
  });
  return {
    type: SET_XRAY_INPAGE_GATHERER_KEYS,
    payload: {
      inpageGathererKeys
    }
  };
};
export const setXrayInpageGathererArtifacts = artifacts => {
  return {
    type: SET_XRAY_INPAGE_GATHERER_ARTIFACTS,
    payload: {
      artifacts
    }
  };
};
export const setXrayReadability = (xrayReadabilityType, xrayReadabilityArr) => {
  return {
    type: SET_XRAY_READABILITY,
    payload: {
      xrayReadabilityType,
      xrayReadabilityArr
    }
  };
};
export const clearXRayReadability = () => {
  return {
    type: CLEAR_XRAY_READABILITY
  };
};